export { default as FolderRestrictionView } from './FolderRestrictions';
